import { Component, OnDestroy, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { GroupOrder, GroupOrderFriend } from 'ngx-web-api';
import { UiOrchestratorService } from '../../core/services/ui-orchestrator.service';
import { InvitationDialogConfig } from '../../domain/invitation-dialog-config';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { GrouporderInvitationModalContext } from 'app/domain/grouporder-invitation-modal-context';
import { from, Subject } from 'rxjs';
import { map, mergeMap, takeUntil } from 'rxjs/operators';

@Component({
  selector: 'fts-grouporder-invitation-modal',
  templateUrl: './grouporder-invitation-modal.component.html',
  styleUrls: ['./grouporder-invitation-modal.component.scss'],
})
export class GrouporderInvitationModalComponent implements OnInit, OnDestroy {
  @ViewChild('content', { read: ViewContainerRef, static: true })
  private content: ViewContainerRef;
  public context: GrouporderInvitationModalContext;
  groupOrder?: GroupOrder;
  groupOrderingFriends: GroupOrderFriend[];
  invitationDialogConfig: InvitationDialogConfig;
  changeExpirationMode: boolean;
  loadingContent = false;
  private destroy$: Subject<void> = new Subject<void>();

  constructor(private uiOrchestratorService: UiOrchestratorService, private activeModal: NgbActiveModal) {}

  ngOnInit() {
    this.groupOrder = this.context.groupOrder;
    this.groupOrderingFriends = this.context.groupOrderingFriends;
    this.invitationDialogConfig = this.context.invitationDialogConfig;
    this.changeExpirationMode = this.context.changeExpirationMode;
    this.uiOrchestratorService.informModalOpened();
    this.loadContent();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  handleDone(): void {
    this.activeModal.close(null);
  }

  // The invitation is downloaded on first use, to keep it out of the initial bundle
  private loadContent(): void {
    this.loadingContent = true;
    from(import('../grouporder-invitation/grouporder-invitation.component'))
      .pipe(
        map(({ GrouporderInvitationComponent }) => {
          const invitation = this.content.createComponent(GrouporderInvitationComponent).instance;
          invitation.groupOrder = this.groupOrder;
          invitation.groupOrderingFriends = this.groupOrderingFriends;
          invitation.invitationDialogConfig = this.invitationDialogConfig;
          invitation.changeExpirationMode = this.changeExpirationMode;
          this.loadingContent = false;
          return invitation;
        }),
        mergeMap(invitation => invitation.done),
        takeUntil(this.destroy$)
      )
      .subscribe({
        next: () => this.handleDone(),
        error: error => {
          this.activeModal.close();
        },
      });
  }
}
